const predefinedIcons = [
  {
    id: "email",
    label: "Email",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "phone",
    label: "Phone",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="m19.23 15.26l-2.54-.29a1.99 1.99 0 0 0-1.64.57l-1.84 1.84a15.05 15.05 0 0 1-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2 2 0 0 0-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07c.53 8.54 7.36 15.36 15.89 15.89c1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "facebook",
    label: "facebook",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M12 2.04c-5.5 0-10 4.49-10 10.02c0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89c1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "link",
    label: "Website",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M8 13h8v-2H8zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "location",
    label: "Address",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5M12 2a7 7 0 0 1 7 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 0 1 7-7m0 2a5 5 0 0 0-5 5c0 1 0 3 5 9.71C17 12 17 10 17 9a5 5 0 0 0-5-5"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "chat",
    label: "chat",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M2 22V4q0-.825.588-1.412T4 2h16q.825 0 1.413.588T22 4v12q0 .825-.587 1.413T20 18H6zm4-8h8v-2H6zm0-3h12V9H6zm0-3h12V6H6z"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "instagram",
    label: "instagram",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <g fill="none" stroke="#000" strokeWidth={1.5}>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8"
          ></path>
          <path d="M3 16V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5Z"></path>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m17.5 6.51l.01-.011"
          ></path>
        </g>
      </svg>
    ),
  },
  {
    id: "x",
    label: "X",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 16 16"
      >
        <path
          fill="#000"
          d="M9.294 6.928L14.357 1h-1.2L8.762 6.147L5.25 1H1.2l5.31 7.784L1.2 15h1.2l4.642-5.436L10.751 15h4.05zM7.651 8.852l-.538-.775L2.832 1.91h1.843l3.454 4.977l.538.775l4.491 6.47h-1.843z"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "whatsapp",
    label: "whatsapp",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.23 8.23 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.2 8.2 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73c.59.27 1.05.42 1.41.53c.59.19 1.13.16 1.56.1c.48-.07 1.46-.6 1.67-1.18s.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27c-.25-.14-1.47-.74-1.69-.82c-.23-.08-.37-.12-.56.12c-.16.25-.64.81-.78.97c-.15.17-.29.19-.53.07c-.26-.13-1.06-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.12-.24-.01-.39.11-.5c.11-.11.27-.29.37-.44c.13-.14.17-.25.25-.41c.08-.17.04-.31-.02-.43c-.06-.11-.56-1.35-.77-1.84c-.2-.48-.4-.42-.56-.43c-.14 0-.3-.01-.47-.01"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "linkedin",
    label: "linkedin",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M20.47 2H3.53a1.45 1.45 0 0 0-1.47 1.43v17.14A1.45 1.45 0 0 0 3.53 22h16.94a1.45 1.45 0 0 0 1.47-1.43V3.43A1.45 1.45 0 0 0 20.47 2M8.09 18.74h-3v-9h3ZM6.59 8.48a1.56 1.56 0 1 1 0-3.12a1.57 1.57 0 1 1 0 3.12m12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2A1.65 1.65 0 0 0 12.85 13a2 2 0 0 0-.1.73v5h-3v-9h3V11a3 3 0 0 1 2.71-1.5c2 0 3.45 1.29 3.45 4.06Z"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "youtube",
    label: "youtube",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="m10 15l5.19-3L10 9zm11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "snapchat",
    label: "snapchat",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <g fill="none" fillRule="evenodd">
          <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path>
          <path
            fill="#000"
            d="M12 2a6 6 0 0 0-6 6v1.875L5.1 9.2a1 1 0 1 0-1.2 1.6l1.866 1.4c-.444 1.168-1.527 2.39-3.28 3.443a1.01 1.01 0 0 0-.318 1.412C3.286 18.732 5.06 20 7 20c.677 0 1.203.43 1.724.809C9.456 21.34 10.423 22 12 22s2.543-.659 3.275-1.191C15.797 20.429 16.323 20 17 20c1.94 0 3.714-1.268 4.832-2.945a1.01 1.01 0 0 0-.318-1.412c-1.753-1.053-2.836-2.275-3.28-3.443l1.866-1.4a1 1 0 0 0-1.2-1.6l-.9.675V8a6 6 0 0 0-6-6M8 8a4 4 0 0 1 8 0v3c0 2.198 1.42 4.209 3.538 5.735C18.752 17.556 17.825 18 17 18c-1.378 0-2.264.728-2.9 1.191c-.644.468-1.177.809-2.1.809s-1.457-.341-2.1-.809C9.265 18.728 8.379 18 7 18c-.826 0-1.752-.444-2.538-1.265C6.58 15.209 8 13.199 8 11z"
            strokeWidth={0}
            stroke="#000"
          ></path>
        </g>
      </svg>
    ),
  },
  {
    id: "threads",
    label: "threads",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M17.692 11.124a9 9 0 0 0-.315-.143c-.185-3.414-2.05-5.368-5.182-5.388h-.042c-1.873 0-3.431.8-4.39 2.255l1.722 1.181c.716-1.087 1.84-1.318 2.669-1.318h.028c1.031.006 1.81.306 2.313.89c.367.426.612 1.015.733 1.757a13.2 13.2 0 0 0-2.96-.143c-2.977.172-4.892 1.909-4.763 4.322c.065 1.223.675 2.277 1.717 2.964c.88.582 2.015.866 3.194.802c1.558-.085 2.78-.68 3.632-1.766c.647-.825 1.056-1.894 1.237-3.241c.742.448 1.292 1.037 1.596 1.745c.516 1.205.546 3.184-1.068 4.797c-1.415 1.414-3.116 2.025-5.686 2.044c-2.851-.02-5.008-.935-6.41-2.717c-1.313-1.67-1.991-4.08-2.016-7.165c.025-3.085.703-5.496 2.016-7.165c1.402-1.782 3.558-2.696 6.41-2.717c2.871.02 5.065.94 6.521 2.73c.714.879 1.252 1.983 1.607 3.27l2.018-.538c-.43-1.585-1.107-2.95-2.027-4.083C18.38 1.2 15.65.024 12.134 0h-.014C8.61.024 5.912 1.205 4.099 3.51c-1.614 2.05-2.446 4.904-2.474 8.482v.016c.028 3.578.86 6.431 2.474 8.482c1.813 2.305 4.511 3.486 8.02 3.51h.015c3.12-.022 5.319-.838 7.13-2.649c2.371-2.368 2.3-5.336 1.518-7.158c-.56-1.307-1.629-2.368-3.09-3.07m-5.387 5.064c-1.305.074-2.66-.512-2.728-1.766c-.05-.93.662-1.969 2.808-2.092q.369-.022.724-.021c.78 0 1.508.075 2.171.22c-.247 3.088-1.697 3.59-2.975 3.66"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "twitch",
    label: "twitch",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M4.301 3h16.7v11.7l-4.7 4.7h-3.9l-2.5 2.4h-2.9v-2.4h-4V6.2zm.7 14.4h4v2.4h.095l2.5-2.4h3.877L19 13.872V5H5zm10-9.4h2v4.7h-2zm0 0h2v4.7h-2zm-5 0h2v4.7h-2z"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "wechat",
    label: "wechat",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M15.85 8.14c.39 0 .77.03 1.14.08C16.31 5.25 13.19 3 9.44 3c-4.25 0-7.7 2.88-7.7 6.43c0 2.05 1.15 3.86 2.94 5.04L3.67 16.5l2.76-1.19c.59.21 1.21.38 1.87.47c-.09-.39-.14-.79-.14-1.21c-.01-3.54 3.44-6.43 7.69-6.43M12 5.89a.96.96 0 1 1 0 1.92a.96.96 0 0 1 0-1.92M6.87 7.82a.96.96 0 1 1 0-1.92a.96.96 0 0 1 0 1.92"
          strokeWidth={0}
          stroke="#000"
        ></path>
        <path
          fill="#000"
          d="M22.26 14.57c0-2.84-2.87-5.14-6.41-5.14s-6.41 2.3-6.41 5.14s2.87 5.14 6.41 5.14c.58 0 1.14-.08 1.67-.2L20.98 21l-1.2-2.4c1.5-.94 2.48-2.38 2.48-4.03m-8.34-.32a.96.96 0 1 1 .96-.96c.01.53-.43.96-.96.96m3.85 0a.96.96 0 1 1 0-1.92a.96.96 0 0 1 0 1.92"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "kik",
    label: "kik",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 32 32"
      >
        <path
          fill="#000"
          d="M15.307 22.339a1.657 1.657 0 0 1-1.651 1.651A1.65 1.65 0 0 1 12 22.355h-.021v-8.328H12v-.037c0-.921.74-1.677 1.651-1.677c.907 0 1.647.756 1.647 1.677v.063h.02v8.303h-.02zm14.849-6.522c1 0 1.844.823 1.844 1.833c0 1.016-.844 1.833-1.844 1.833a1.85 1.85 0 0 1-1.859-1.839c0-1.02.823-1.839 1.839-1.839zm-2.776 5.584c.161.255.256.572.256.911c0 .939-.735 1.683-1.657 1.683a1.66 1.66 0 0 1-1.443-.844l-2.733-3.661l-.844.781v2.183h-.016a1.644 1.644 0 0 1-1.636 1.557c-.895 0-1.624-.74-1.624-1.651v-.037h-.027V9.724h.037v-.063c0-.916.733-1.672 1.64-1.672c.901 0 1.636.751 1.636 1.672v.093h.02l.016 6.131l3.077-3.016a1.65 1.65 0 0 1 1.24-.541c.917 0 1.661.76 1.661 1.683c0 .463-.177.859-.457 1.161l.015.021l-2.161 2.14l3.041 4.079l-.02.02zm-17.661 0c.161.255.26.572.26.911c0 .939-.739 1.683-1.661 1.683c-.62 0-1.161-.344-1.437-.844l-2.74-3.661l-.837.781v2.177h-.021a1.64 1.64 0 0 1-1.631 1.557a1.64 1.64 0 0 1-1.629-1.651v-.037H.002V9.718h.041c-.005-.021-.005-.036-.005-.057c0-.921.735-1.672 1.641-1.672c.901 0 1.629.751 1.629 1.667v.093h.021l.016 6.136l3.083-3.016a1.66 1.66 0 0 1 1.24-.541c.917 0 1.661.76 1.661 1.683c0 .443-.177.859-.464 1.161l.021.021l-2.167 2.14l3.027 4.079l-.021.02z"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "soundcloud",
    label: "soundcloud",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M4 10a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1m3 1a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m3-4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m5-1a6 6 0 0 1 5.996 5.775l.003.26a3.5 3.5 0 0 1-.307 6.96L20.5 19h-3.501a1 1 0 0 1-.117-1.993L17 17h3.447l.138-.002a1.5 1.5 0 0 0 .267-2.957l-.135-.026l-1.77-.252l.053-1.787l-.004-.176A4 4 0 0 0 15.2 8.005L15 8q-.402 0-.788.077L14 8.126v9.875a1 1 0 0 1-.883.992L13 19a1 1 0 0 1-1-1V6.804A6 6 0 0 1 15 6M1 12a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1"
          strokeWidth={0.5}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "spotify",
    label: "spotify",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <g fill="none">
          <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path>
          <path
            fill="#000"
            d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16M7.728 14.111c1.418-.326 2.935-.322 4.247-.119c1.276.198 2.514.61 3.277 1.234a1 1 0 0 1-1.164 1.622l-.102-.073c-.356-.292-1.178-.63-2.318-.806c-1.105-.172-2.362-.168-3.492.091a1 1 0 1 1-.448-1.949m-.52-2.731c3.259-.909 7.05-.395 9.363 1.025a1 1 0 0 1-1.047 1.705c-1.783-1.095-4.99-1.581-7.78-.804a1 1 0 1 1-.536-1.926M6.73 8.514c3.76-1.05 7.496-.505 10.666.864a1 1 0 0 1-.793 1.836c-2.83-1.223-6.094-1.678-9.335-.774a1 1 0 1 1-.538-1.926"
            strokeWidth={0.5}
            stroke="#000"
          ></path>
        </g>
      </svg>
    ),
  },
  {
    id: "gitHub",
    label: "github",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
      >
        <path
          fill="#000"
          d="M12.001 2c-5.525 0-10 4.475-10 10a9.99 9.99 0 0 0 6.837 9.488c.5.087.688-.213.688-.476c0-.237-.013-1.024-.013-1.862c-2.512.463-3.162-.612-3.362-1.175c-.113-.288-.6-1.175-1.025-1.413c-.35-.187-.85-.65-.013-.662c.788-.013 1.35.725 1.538 1.025c.9 1.512 2.337 1.087 2.912.825c.088-.65.35-1.087.638-1.337c-2.225-.25-4.55-1.113-4.55-4.938c0-1.088.387-1.987 1.025-2.687c-.1-.25-.45-1.275.1-2.65c0 0 .837-.263 2.75 1.024a9.3 9.3 0 0 1 2.5-.337c.85 0 1.7.112 2.5.337c1.913-1.3 2.75-1.024 2.75-1.024c.55 1.375.2 2.4.1 2.65c.637.7 1.025 1.587 1.025 2.687c0 3.838-2.337 4.688-4.562 4.938c.362.312.675.912.675 1.85c0 1.337-.013 2.412-.013 2.75c0 .262.188.574.688.474A10.02 10.02 0 0 0 22 12c0-5.525-4.475-10-10-10"
          strokeWidth={0.5}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
  {
    id: "line",
    label: "line",
    preview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 12 12"
      >
        <path
          fill="#000"
          d="M6 .25c3.309 0 6 2.197 6 4.897c0 1.08-.417 2.054-1.286 3.012C9.455 9.617 6.641 11.392 6 11.664a.9.9 0 0 1-.33.086c-.272 0-.21-.294-.19-.412l.085-.516c.021-.155.042-.394-.018-.545c-.067-.17-.334-.256-.529-.298C2.135 9.595 0 7.567 0 5.147C0 2.447 2.691.25 6 .25m0 1.006C3.243 1.256 1 3 1 5.147C1 7.05 2.745 8.661 5.148 8.981l.041.006l.04.008c.641.139 1.06.444 1.246.905q.054.139.082.294c1.034-.652 2.59-1.753 3.402-2.693C10.675 6.71 11 5.969 11 5.147c0-2.146-2.243-3.891-5-3.891M4.781 3.842c.064 0 .116.052.116.117v2.63a.117.117 0 0 1-.116.117h-.42a.117.117 0 0 1-.118-.117v-2.63c0-.065.053-.117.117-.117zm1.068 0h.006q.011.001.01.002h.008l.01.005l.005.001l.007.003l.003.002l.007.004l.002.002l.007.003l.001.001c.009.007.009.008.01.01q.004.002.007.006v.001l.01.012L7.14 5.522V3.959c0-.065.053-.117.117-.117h.42c.065 0 .118.052.118.117v2.63a.117.117 0 0 1-.117.117h-.421q-.016 0-.03-.004q-.006 0-.01-.003q-.002 0-.003-.002l-.006-.002l-.01-.005l-.007-.005a.1.1 0 0 1-.03-.029l-1.2-1.628v1.56a.117.117 0 0 1-.116.118h-.421a.117.117 0 0 1-.117-.117v-2.63c0-.065.053-.117.117-.117zm4.153 0c.064 0 .116.053.116.118v.423a.116.116 0 0 1-.116.117H8.858v.445h1.144c.064 0 .116.052.116.118v.422a.117.117 0 0 1-.116.118H8.858v.445h1.144c.064 0 .116.052.116.117v.423a.12.12 0 0 1-.116.118H8.32a.12.12 0 0 1-.081-.033l-.001-.002a.11.11 0 0 1-.034-.082v-2.63q.001-.048.032-.08q0-.002.002-.003a.12.12 0 0 1 .082-.034zm-7.496 0c.065 0 .117.052.117.117v2.089h1.144c.064 0 .116.052.116.117v.423a.117.117 0 0 1-.116.118H2.085a.12.12 0 0 1-.081-.033l-.001-.002a.12.12 0 0 1-.034-.082v-2.63c0-.065.052-.117.116-.117z"
          strokeWidth={0}
          stroke="#000"
        ></path>
      </svg>
    ),
  },
];

export { predefinedIcons };
